/**
 * @purpose: mengelola halaman audit trail dengan pencarian manual berdasarkan indeks dan kegiatan tanpa auto-load dan tanpa filter periode.
 * @called_by: views/app_report/audit_trail.html.
 * @deps: AngularJS app, urlServices, toaster.
 * @public: auditTrailCtrl.
 * @side_effects: memanggil API audit trail hanya saat user menekan Tampilkan atau berpindah halaman hasil pencarian.
 */
app.controller('auditTrailCtrl', ['$scope', 'urlServices', 'toaster', function ($scope, urlServices, toaster) {
    $scope.filters = {
        indeks: '',
        kegiatan: ''
    };
    $scope.hasSubmitted = false;
    $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: 20
    };
    $scope.dataList = {
        totalItems: 0,
        data: []
    };

    function normalizeTextValue(value) {
        return String(value === undefined || value === null ? '' : value).trim();
    }

    function hasActiveFilters() {
        return !!normalizeTextValue($scope.filters && $scope.filters.indeks) || !!normalizeTextValue($scope.filters && $scope.filters.kegiatan);
    }

    function resetResult() {
        $scope.paginationOptions.pageNumber = 1;
        $scope.dataList.totalItems = 0;
        $scope.dataList.data = [];
    }

    function normalizeError(err, fallbackMessage) {
        var rawMessage = '';

        if (!err) {
            return fallbackMessage || 'Error tidak terdeteksi';
        }
        rawMessage = String(err.err || err.message || err || '');

        if (/<html/i.test(rawMessage) || /504\s*gateway/i.test(rawMessage) || /time-?out/i.test(rawMessage)) {
            return 'Pencarian audit trail timeout. Coba sempitkan keyword pencarian.';
        }
        if (err.err) {
            return err.err;
        }
        if (err.message) {
            return err.message;
        }
        return String(err);
    }

    function buildQuery(page) {
        return [
            'limit=' + encodeURIComponent($scope.paginationOptions.pageSize),
            'pg=' + encodeURIComponent(page || 1),
            'indeks=' + encodeURIComponent(($scope.filters && $scope.filters.indeks) || ''),
            'kegiatan=' + encodeURIComponent(($scope.filters && $scope.filters.kegiatan) || '')
        ].join('&');
    }

    $scope.viewData = function (page) {
        if (!$scope.hasSubmitted || !hasActiveFilters()) {
            return;
        }

        $scope.paginationOptions.pageNumber = page || 1;
        return urlServices.ambilData('api/audit-trail?' + buildQuery($scope.paginationOptions.pageNumber), {}, function (err, result) {
            if (err) {
                resetResult();
                return toaster.pop('error', 'Audit Trail', normalizeError(err, 'Gagal memuat audit trail'));
            }

            $scope.dataList.totalItems = result && result.records ? result.records : 0;
            $scope.dataList.data = result && result.data ? result.data : [];
        });
    };

    $scope.tampilkan = function () {
        if (!hasActiveFilters()) {
            $scope.hasSubmitted = false;
            resetResult();
            return toaster.pop('warning', 'Audit Trail', 'Isi pencarian indeks atau kegiatan terlebih dahulu');
        }

        $scope.hasSubmitted = true;
        $scope.viewData(1);
    };

    $scope.resetFilter = function () {
        $scope.filters.indeks = '';
        $scope.filters.kegiatan = '';
        $scope.hasSubmitted = false;
        resetResult();
    };
}]);